import { Row, Form } from 'react-bootstrap';

import './styles.scoped.css';

export const MatchCalcForm = ({ form, handleChange, errors }) => (
  <div className="filters-container">
    <span>
      Check totals for the year of the selected date are from January 1 of that year and including checks paid by the
      date selected.
    </span>
    <div className="filter-row" style={{ marginTop: '30px' }}>
      <Form.Group as={Row} controlId="EffectiveDate" style={{ alignItems: 'center' }}>
        <Form.Label style={{ width: '280px' }}>
          <div className="required">Effective Date</div>
        </Form.Label>
        <Form.Control
          style={{ width: '150px', height: '30px' }}
          as="input"
          type="date"
          name="EffectiveDate"
          value={form?.EffectiveDate || ''}
          onChange={handleChange}
        />
      </Form.Group>
    </div>
    {errors?.EffectiveDate && <div className="field-error">{errors.EffectiveDate}</div>}
    <div className="filter-row">
      <Form.Group as={Row} controlId="MatchPercentage" style={{ alignItems: 'center' }}>
        <Form.Label style={{ width: '280px' }}>
          <div className="required">401K Match Percentage</div>
        </Form.Label>
        <Form.Control
          style={{ width: '150px', height: '30px' }}
          as="input"
          type="number"
          step="0.001"
          min="0"
          name="MatchPercentage"
          value={form?.MatchPercentage ?? ''}
          onChange={handleChange}
        />
      </Form.Group>
    </div>
    {errors?.MatchPercentage && <div className="field-error">{errors.MatchPercentage}</div>}
    <div className="filter-row">
      <Form.Group as={Row} controlId="Threshold" style={{ alignItems: 'center' }}>
        <Form.Label style={{ width: '280px' }}>
          <div className="required">Total Contribution Threshold Value</div>
        </Form.Label>
        <Form.Control
          style={{ width: '150px', height: '30px' }}
          as="input"
          type="number"
          step="0.01"
          min="0"
          name="Threshold"
          value={form?.Threshold ?? ''}
          onChange={handleChange}
        />
      </Form.Group>
    </div>
    {errors?.Threshold && <div className="field-error">{errors.Threshold}</div>}
  </div>
);
